// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

import { InferenceSession, Tensor } from "onnxruntime-web";
import React, { useContext, useEffect, useState } from "react";
import "./assets/scss/App.scss";
import { Button, Input } from '@material-tailwind/react';
import { handleImageScale, handleVideoImageScale } from "./components/helpers/scaleHelper";
import { modelScaleProps, StageAppProps, StageVideoAppProps} from "./components/helpers/Interfaces";
import { onnxMaskToImage, arrayToMaskArray, allOnesMaskArray } from "./components/helpers/maskUtils";
import { modelData } from "./components/helpers/onnxModelAPI";
import DragDropFile from "./components/DragDropFile";
import Stage from "./components/Stage";
import { AppContext } from "./components/hooks/createContext";
const ort = require("onnxruntime-web");
const axios = require("axios");
const SERVER_URL = "https://ai4sports.opengvlab.com/interp/api";

/* @ts-ignore */
import npyjs from "npyjs";

// Define image, embedding and model paths

const StageVideoApp = ({updateLoader, onUploadVideo, onSetType, uploadType , onFitWidth}: StageVideoAppProps) => {
  
  const [video, setVideo] = useState<HTMLVideoElement | null>(null);
  const loadVideo = async (url: URL) => {
    try {
    //   const vid = new Player();
      const vid = document.createElement("video");
    //   const vid = new Video
      updateLoader(true);
      vid.src = url.href;
      updateLoader(false);
    //   console.log(vid)
    //   vid.onloadedmetadata = () => {
    //     const { height, width } = handleVideoImageScale(vid);
    //     vid.width = width; 
    //     vid.height = height; 
    //     // setImage2(img);
    //     setVideo(vid);
    //   };
        setVideo(vid);
    } catch (error) {
      console.log(error);
    }
  };

  const [shouldFitToWidth, setShouldFitToWidth] = useState(true);
  const bodyEl = document.body;
  const fitToPage = () => {
    if (!video) return;
    const imageAspectRatio = video.width / video.height;
    const screenAspectRatio = window.innerWidth / window.innerHeight;
    setShouldFitToWidth(imageAspectRatio > screenAspectRatio);
    onFitWidth(imageAspectRatio > screenAspectRatio);
  };
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      if (entry.target === bodyEl) {
        fitToPage();
      }
    }
  });
  useEffect(() => {
    fitToPage();
    resizeObserver.observe(bodyEl);
    return () => {
      resizeObserver.unobserve(bodyEl);
    };
  }, [video]);
  const imageClasses = "";
  

  const clearVideo = (event: { target: any; }) => {
    setVideo(null);
    onUploadVideo("");
  };
  

  const onVideoUploaded = (url: URL, fileName: string) => {
    loadVideo(url);
    onUploadVideo(url.href);
  }

  useEffect(() => {
    // Initialize the ONNX model
    const initImage = async () => {
      try {
        //const default_url1 = new URL("http://10.6.8.70:5001/uploads/d45864a6-164a-4d01-b6e1-ea9168b849af.png");
        //const default_url2 = new URL("http://10.6.8.70:5001/uploads/bbbc194e-117e-463f-af8b-7fcd50244c1e.png");
        // onImage1Uploaded(default_url1, 'd45864a6-164a-4d01-b6e1-ea9168b849af.png');
        // onImage2Uploaded(default_url2,"cd304d0f-e678-48c1-bc6d-07e7b663f1e7.png")

        const default_video_url = new URL("https://ai4sports.opengvlab.com/interp/api/uploads/video_demo.mp4");
        // const default_url2 = new URL("http://10.6.8.70:5001/uploads/video_demo.mp4");
        // const default_video_url = new URL("http://10.6.8.70:5001/uploads/video_demo.mp4")
        // onImage1Uploaded(default_url1, 'img0.png');
        onUploadVideo(default_video_url.href)
        loadVideo(default_video_url)

      } catch (e) {
        console.log(e);
      }
    };
    initImage();

  }, []);
  // const default_url1 = new URL("http://ai4sports.opengvlab.com/interp/api/uploads/8a9b62be-42c1-4715-b718-26db3913504a.png");
  // const default_url2 = new URL("http://ai4sports.opengvlab.com/interp/api/uploads/cd304d0f-e678-48c1-bc6d-07e7b663f1e7.png");

  // add default
  // onImage1Uploaded(default_url1, 'd45864a6-164a-4d01-b6e1-ea9168b849af.png');
  // onImage2Uploaded(default_url2,"cd304d0f-e678-48c1-bc6d-07e7b663f1e7.png")

  // view returned
  const flexCenterClasses = "flex items-center justify-center";
//   onFitWidth(shouldFitToWidth);
  return (
    <div className="column h-full">
      <span>
      <Button className="m-2" size="md" color={`${!uploadType ? "pink" : "gray"}`}  onClick={()=>{onSetType(false);}}>image</Button>
      <Button className="m-2" size="md" color={`${uploadType ? "pink" : "gray"}`} onClick={()=>{onSetType(true);}}>video</Button>
      </span>
      <div className="row h-[50%] mb-16">
        <div className={`${flexCenterClasses} w-full h-full`}>
          <div className={`${flexCenterClasses} relative w-[90%] h-[85%]`}>
            {
              !video && (
                <DragDropFile message="Drag and drop video file (< 10 seconds)" uploadedCallback={onVideoUploaded }/>
              )
            }
            {video && (
              <div className={`${flexCenterClasses} relative w-full h-full image-container`}>
                <img src='images/close_button.png' className='close-button' onClick={clearVideo}/>
               
                <video controls src={video.src} className={`${
                    shouldFitToWidth ? "w-full" : "h-full"
                  } ${imageClasses}`}

                  ></video>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StageVideoApp;
